import { useQueries } from '@taxdown/zeno-sama-query';
import cardValidator from 'card-validator';
import CheckoutService from 'Services/checkout';
import { QueryKeys } from 'Types/common';

type ValidationResult = {
  isValid: boolean;
  error?: string;
  bankTag?: string;
  isLoading?: boolean;
  bankName?: string;
};

export const hasError = (clabeAccount?: string, isValid?: boolean): boolean => {
  const isCardValid = cardValidator.number(clabeAccount).isValid;
  const hasCardLength = clabeAccount?.length === 16;
  return (isCardValid && hasCardLength) || clabeAccount ? !isValid : false;
};

export const getErrorContext = (clabeAccount?: string, error?: string): string | null => {
  const isCardValid = cardValidator.number(clabeAccount).isValid;
  const hasCardLe = clabeAccount?.length === 16;
  return isCardValid && hasCardLe ? 'card_number' : error || null;
};

const useValidateClabe = (clabeNumber: string): ValidationResult => {
  const data = useQueries({
    queries: [
      {
        queryKey: [QueryKeys.VALIDATE_CLABE, clabeNumber],
        queryFn: () => CheckoutService.getValidationClabe({ clabe: clabeNumber }),
        enabled: Boolean(clabeNumber),
        retry: false,
      },
    ],
  });

  const isFormatValid = Boolean(data[0]?.data?.data?.item?.isFormatValid);
  const isPayLaterValid = Boolean(data[0]?.data?.data?.item?.isPayLaterAllowed);
  const isBlackListed = Boolean(data[0]?.data?.data?.item?.isBlackListed);

  if (isFormatValid && isPayLaterValid && !isBlackListed) {
    return {
      isValid: true,
      bankTag: data[0]?.data?.data?.item?.bankTag,
      isLoading: data[0]?.isLoading,
      bankName: data[0]?.data?.data?.item?.bankName,
    };
  }

  if (!isFormatValid) {
    return {
      isValid: false,
      error: data[0]?.data?.data?.item?.formatError || 'invalid-format',
      isLoading: data[0]?.isLoading,
    };
  }

  if (!isPayLaterValid) {
    return {
      isValid: false,
      error: data[0]?.data?.data?.item?.formatError || 'pay-later-not-allowed',
      isLoading: data[0]?.isLoading,
      bankName: data[0]?.data?.data?.item?.bankName,
    };
  }

  if (isBlackListed) {
    return {
      isValid: false,
      error: data[0]?.data?.data?.item?.formatError || 'blacklisted-clabe',
      isLoading: data[0]?.isLoading,
      bankName: data[0]?.data?.data?.item?.bankName,
    };
  }

  return {
    isValid: false,
    error: 'invalid-clabe',
    isLoading: data[0]?.isLoading,
    bankName: data[0]?.data?.data?.item?.bankName,
  };
};

export default useValidateClabe;
